import React, { Component } from 'react';

// Components
import ProfileTabSection from '../../../components/Profile/ProfileTabSection';
import ProfileDataBlock from '../../../components/Profile/ProfileDataBlock';

// Helpers
import { toTitleCase } from '../../../utils/helpers'

const SchoolContact = ({ school }) => (
  <ProfileDataBlock heading="School">
    <div className="school-contact">
      <h4>
        {toTitleCase(school.school_name)}
      </h4>
      <p>
        {school.address}
        <br/>
        {school.city}, {school.state} {school.zip}
        <br/>
        {school.phone}
      </p>
    </div>
  </ProfileDataBlock>
)

const ContactList = ({ name, contacts }) => {
  return contacts.length > 0
  ? (
    <ProfileDataBlock heading={name}>
      <ul className="contact-list">
        {
          contacts.map((contact, i) => (
            <li key={i} className="contact-list-item">
              <div className="contact-list-item-section">
                <h4>
                  Name
                </h4>
                <p>
                  {contact.name}
                </p>
              </div>

              <div className="contact-list-item-section">
                <h4 className="contact-list-item-heading">
                  Relationship
                </h4>
                <p>
                  {contact.relationship}
                </p>
              </div>

              <div className="contact-list-item-section">
                <h4 className="contact-list-item-heading">
                  Email
                </h4>
                <p>
                  {contact.email}
                </p>
              </div>

              <div className="contact-list-item-section">
                <h4 className="contact-list-item-heading">
                  Phone
                </h4>
                <p>
                  {contact.phone}{contact.phone_extension ? ' x' + contact.phone_extension : ''}
                </p>
              </div>
            </li>
          ))
        }
      </ul>
    </ProfileDataBlock>
  ) : null
}

class PlayerProfileContact extends Component {

  contactGroupNames = () => {
    const { school, ...groups } = this.props.contacts
    return Object.keys(groups)
  }

  render() {
    const { contacts } = this.props

    return (
      <ProfileTabSection heading="Contact" optionalClasses="player-profile-contact">
        <SchoolContact school={contacts.school} />
        {
          this.contactGroupNames().map((name, index) => <ContactList key={index} name={name} contacts={contacts[name]}/>)
        }
      </ProfileTabSection>
    )
  }
}

export default PlayerProfileContact;



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileSections/PlayerProfileContact.js